
























import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import Enumerable from "linq";
import { IConfiguration } from "../../../domain/configuration";
import { ModelEditableMixin } from "../../../../base/components/system/mixins";
import EditableFormatSummaryDirectoryFilter from "./EditableFormatSummaryDirectoryFilter.vue";
import EditableFormatSummaryFilter from "./EditableFormatSummaryFilter.vue";
import EditableFormatSummaryMasterCodeFilter from "./EditableFormatSummaryMasterCodeFilter.vue";
import EditableFormatSummaryDocumentKindFilter from "./EditableFormatSummaryDocumentKindFilter.vue";
import EditableFormatSummaryTagFilter from "./EditableFormatSummaryTagFilter.vue";
import { EditableFormatSummaryDirectoryFilterParameter, EditableFormatSummaryFilterParameter, EditableFormatSummaryTreeFilterParameter } from ".";

@Component({
  components: {
    EditableFormatSummaryFilter,
    EditableFormatSummaryMasterCodeFilter,
    EditableFormatSummaryDocumentKindFilter,
    EditableFormatSummaryTagFilter,
    EditableFormatSummaryDirectoryFilter,
  },
})
export default class EditableFormatSummaryTreeFilter extends Mixins(ModelEditableMixin) {
  readPropertyOrDefault: <T>(reader: (source: EditableFormatSummaryTreeFilterParameter) => T, defaultValue: T) => T;
  writeProperty: (writer: (source: EditableFormatSummaryTreeFilterParameter) => void) => void;

  @Prop({ default: false })
  expand: boolean;

  @Prop({ default: false })
  visibleExpired: boolean;

  @Prop({ default: false })
  visibleDeleted: boolean;

  activeNames: string[] = [];
  updatedMasterCode: string = "";
  updatedDocumentKind: string = "";

  $configuration!: IConfiguration;

  mounted(): void {
    this.updateActiveNames();
  }

  private updateActiveNames(): void {
    this.activeNames = this.expand
      ? ["1"]
      : [];
  }

  get conditionsString(): string {
    const text = Enumerable.from([
      this.containsExpiredConditionString,
      this.containsDeletedConditionString,
      this.directoryNameConditionString,
      this.formatNameConditionString,
      this.masterCodeConditionString,
      this.documentKindConditionString,
      this.tagConditionString,
    ])
    .where(t => !!t)
    .toArray()
    .join("");
    return "絞り込み：" + (text ? text : "なし");
  }

  private formatConditionString(name: string, value: string): string {
    return value
      ? (name + "【" + value + "】")
      : "";
  }

  get containsExpiredConditionString(): string {
    return this.formatConditionString(
      "期限切れ",
      (this.visibleExpired && this.containsExpired) ? "含む" : null);
  }

  get containsDeletedConditionString(): string {
    return this.formatConditionString(
      "削除済",
      (this.visibleDeleted && this.containsDeleted) ? "含む" : null);
  }

  get directoryNameConditionString(): string {
    return this.formatConditionString(
      "フォルダ名称",
      this.directory ? this.directory.name.keyword : null);
  }

  get formatNameConditionString(): string {
    return this.formatConditionString(
      this.$wording.format.name + "名称",
      this.reference ? this.reference.name.keyword : null);
  }

  get masterCodeConditionString(): string {
    return this.formatConditionString(
      "整理番号",
      this.updatedMasterCode);
  }

  get documentKindConditionString(): string {
    return this.formatConditionString(
      this.$wording.format.attributes.name + "種別",
      this.updatedDocumentKind);
  }

  get tagConditionString(): string {
    return this.formatConditionString(
      "タグ",
      this.reference ? this.reference.tag.keyword : null);
  }

  get containsExpired(): boolean {
    return this.readPropertyOrDefault(s => s.reference.containsExpired, null);
  }

  set containsExpired(source: boolean) {
    this.writeProperty(s => s.reference.containsExpired = source);
  }

  get containsDeleted(): boolean {
    return this.readPropertyOrDefault(s => s.reference.containsDeleted, null);
  }

  set containsDeleted(source: boolean) {
    this.writeProperty(s => s.reference.containsDeleted = source);
  }

  get reference(): EditableFormatSummaryFilterParameter {
    return this.readPropertyOrDefault(s => s.reference, null);
  }

  set reference(source: EditableFormatSummaryFilterParameter) {
    this.writeProperty(s => s.reference = source);
  }

  get directory(): EditableFormatSummaryDirectoryFilterParameter {
    return this.readPropertyOrDefault(s => s.directory, null);
  }

  set directory(source: EditableFormatSummaryDirectoryFilterParameter) {
    this.writeProperty(s => s.directory = source);
  }

  get shouldShowMasterCodeFilter(): boolean {
    return this.$configuration.formatEditor.behavior.format.list.filters.masterCode.isEnable;
  }

  get shouldShowTagFilter(): boolean {
    return this.$configuration.formatEditor.behavior.format.list.filters.tag.isEnable;
  }

  @Watch("expand")
  onExpandUpdated(newValue: boolean, oldValue: boolean): void {
    this.updateActiveNames();
  }

  @Watch("visibleExpired")
  onContainsExpiredUpdated(newValue: boolean, oldValue: boolean): void {
    if (!newValue) {
      this.writeProperty(s => s.reference.containsExpired = newValue);
    }
  }

  @Watch("visibleDeleted")
  onContainsDeletedUpdated(newValue: boolean, oldValue: boolean): void {
    if (!newValue) {
      this.writeProperty(s => s.reference.containsDeleted = newValue);
    }
  }

  clear(): void {
    this.writeProperty(s => s.clear());
  }
}
